import { css } from '@emotion/css';
import { Button, Divider } from '@material-ui/core';
import TodayIcon from '@material-ui/icons/Today';
import { setNotificationsStatus } from '@webapps/business';
import {
  Modal,
  useMutation,
  useRouter,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import Affiliations from 'components/Icons/Affiliations';
import notificationData from 'components/Notification/NotificationData';
import { ROUTES_PATH } from 'config/constants';
import { useState } from 'react';
import React from 'react';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';

import theme from '../theme';

const RenderDescriptionWithFormatting = ({ description }) => {
  const formattedParts = description
    ?.split(/(\*.*?\*|_.*?_|\n|\[image:.*?\])/)
    .filter(Boolean)
    .map((part, index) => {
      if (part.startsWith('*') && part.endsWith('*')) {
        return <strong key={index}>{part.slice(1, -1)}</strong>;
      } else if (part.startsWith('_') && part.endsWith('_')) {
        return <em key={index}>{part.slice(1, -1)}</em>;
      } else if (part === '\n') {
        return <br key={index} />;
      } else if (part.startsWith('[image:') && part.endsWith(']')) {
        const imageUrl = part.slice(7, -1);
        return (
          <img
            key={index}
            src={imageUrl}
            alt=""
            className={css({
              maxWidth: '3%',
              height: 'auto',
              verticalAlign: 'middle',
            })}
          />
        );
      } else {
        return part;
      }
    });

  return <>{formattedParts}</>;
};

const Notifications = ({
  notifs,
  totalElements,
  notifsLoading,
  notifsFetching,
}) => {
  const {
    classes,
    css,
    theme: { spacing },
  } = useStyles(styles);
  const intl = useIntl();

  const history = useHistory();
  const { push } = useRouter();
  const [hoveredId, setHoveredId] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [selectedNotification, setSelectedNotification] = useState({});

  const { mutate: mutateSetNotificationStatus } = useMutation(
    setNotificationsStatus
  );

  const goToNotification = async (id) => {
    await mutateSetNotificationStatus({ id });
  };

  const handleOpenModal = (notif) => {
    setOpenModal(true);
    goToNotification(notif?.id);
    setSelectedNotification(notif);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedNotification({});
  };

  const handleMouseEnter = (id) => {
    setHoveredId(id);
  };
  const handleMouseLeave = () => {
    setHoveredId(null);
  };

  const goToPage = (path) => {
    push(path);
  };

  const visibleNotifications =
    window.innerWidth < 1600 ? notifs.slice(0, 2) : notifs;

  return (
    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      })}
    >
      <div className={css({ padding: '20px 20px 0px 20px' })}>
        <h2
          className={css({
            fontSize: 20,
            fontWeight: 600,
            margin: 0,
            fontFamily: 'Montserrat',
            lineHeight: '110%',
            '@media only screen and (max-width:1920px)': { fontSize: '15.0px' },
            '@media only screen and (max-width:1600px)': { fontSize: '15px' },
          })}
        >
          Dernières notifications
        </h2>
      </div>
      <Divider
        fullWidth
        className={css({ marginTop: '20px', marginBottom: '20px' })}
      />
      {notifs && notifs.length > 0 ? (
        <ul
          className={css({
            padding: '0px 20px 0px 20px',
            margin: 0,
          })}
        >
          {visibleNotifications.map((notification, index) => (
            <React.Fragment key={notification?.id}>
              <li
                onClick={() => {
                  handleOpenModal(notification);
                  setSelectedNotification(notification);
                }}
                onMouseEnter={() => handleMouseEnter(notification.id)}
                onMouseLeave={handleMouseLeave}
                className={css({
                  listStyleType: 'none',
                  cursor: 'pointer',
                  borderRadius: 10,
                  marginLeft: -10,
                  padding: 10,
                  '&:hover': {
                    backgroundColor: '#F3F7FF',
                  },
                })}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'start',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      columnGap: 10,
                    }}
                  >
                    <div
                      className={css({
                        padding: 10,
                        backgroundColor:
                          hoveredId === notification.id ? '#0060F9' : '#F3F7FF',
                        borderRadius: 10,
                        fontSize: '30px',
                        color:
                          hoveredId === notification.id ? 'white' : '#0060F9',
                      })}
                    >
                      {
                        notificationData(
                          intl,
                          notification?.type,
                          notification?.attributes,
                          'business',
                          notification?.date
                        )?.icon
                      }
                    </div>
                    <h3
                      className={css({
                        margin: 0,
                        fontFamily: 'Montserrat',
                        lineHeight: '110%',
                        color: '#152652',
                        textDecoration:
                          hoveredId === notification.id ? 'underline' : 'none',
                        '@media only screen and (max-width:1920px)': {
                          fontSize: '15.00px',
                        },
                        '@media only screen and (max-width:1600px)': {
                          fontSize: '14.00px',
                        },
                      })}
                    >
                      {
                        notificationData(
                          intl,
                          notification?.type,
                          notification?.attributes,
                          'business',
                          notification?.date
                        )?.title
                      }
                    </h3>
                  </div>
                </div>
                <p
                  className={css({
                    color: '#152652',
                    margin: '20px 0px 20px 0px',
                    '@media only screen and (max-width:1920px)': {
                      fontSize: '13.500px',
                    },
                    '@media only screen and (max-width:1600px)': {
                      fontSize: '13.5000px',
                    },
                    wordBreak: 'break-word', 
                    overflowWrap: 'break-word'
                  })}
                >
                  {
                    notificationData(
                      intl,
                      notification?.type,
                      notification?.attributes,
                      'business',
                      notification?.date
                    )?.content
                  }
                </p>
                <span
                  className={css({
                    display: 'flex',
                    justifyContent: 'start',
                    alignItems: 'center',
                    color: '#5D75A8',
                    '@media only screen and (max-width:1920px)': {
                      fontSize: '14px',
                    },
                    '@media only screen and (max-width:1600px)': {
                      fontSize: '10px',
                    },
                  })}
                >
                  <TodayIcon
                    className={css({ marginRight: '10px', fontSize: '16.0px' })}
                  />{' '}
                  {new Date(notification?.date).toLocaleDateString('fr-FR', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                  })}{' '}
                  {new Date(notification?.date).toLocaleTimeString('fr-FR', {
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                  })}{' '}
                </span>
              </li>
              <Divider
                style={{
                  display:
                    index === visibleNotifications?.length - 1
                      ? 'none'
                      : 'block',
                  margin: '20px -30px',
                }}
              />
            </React.Fragment>
          ))}
        </ul>
      ) : (
        <p
          className={css({
            textAlign: 'center',
            color: '#5D75A8',
            marginBottom: 0,
            fontFamily: 'Montserrat',
            height: '100%',
          })}
        >
          Aucune notification trouvée
        </p>
      )}
      <div>
        <Button
          fullWidth
          variant="contained"
          onClick={() => {
            // history.push(ROUTES_PATH.BUSINESS_NOTIFICATIONS);
            history.push(ROUTES_PATH.SCHOOL_NOTIFICATIONS);

          }}
          style={{
            marginTop: 20,
            color: '#5A6DA1',
            backgroundColor: '#F3F7FF',
            borderRadius: '10px',
            boxShadow: 'none',
            border: '1px solid #E0E0E0',
          }}
        >
          Tout voir
        </Button>
      </div>
      <Modal
        onCancel={handleCloseModal}
        open={openModal}
        subTitle=""
        title={
          notificationData(
            intl,
            selectedNotification?.type,
            selectedNotification?.attributes,
            'business',
            selectedNotification?.date
          )?.title
        }
        withStep={false}
      >
        <div className={css({ textAlign: 'center', color: '#152652' })}>
          <RenderDescriptionWithFormatting
            description={
              notificationData(
                intl,
                selectedNotification?.type,
                selectedNotification?.attributes,
                'business',
                selectedNotification?.date
              )?.description
            }
          />
        </div>
        <div
          className={css({ display: 'flex', justifyContent: 'center' })}
          item
          xs={12}
        >
          <Button
            className={css({
              fontWeight: 600,
              marginTop: '24px',
              backgroundColor: 'white',
              height: 30,
              width: 120,
            })}
            color="primary"
            onClick={() => {
              goToPage(
                notificationData(
                  intl,
                  selectedNotification?.type,
                  selectedNotification?.attributes,
                  'business',
                  selectedNotification?.date
                )?.path
              );
            }}
            variant="outlined"
          >
            Voir
          </Button>
        </div>
      </Modal>
    </div>
  );
};

const styles = ({ fontSizes, spacing }) => ({
  notificationscontainer: {
    '&:hover': {
      backgroundColor: '#E0E0E0',
    },
  },
  icon: {
    color: '#0060F9',
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '45px',
    height: '45px',
    backgroundColor: '#F3F7FF',
    borderRadius: '10px',
    padding: '5px',
  },
});

export default Notifications;
